import React, { useEffect, useState } from "react";
import axios from "axios";

import "./css/dashboard.css";

import {
  Row,
  Col,
  Layout,
  Card,
  Divider,
  Space,
  Select,
  Button,
  Form,
  Modal,
  InputNumber,
  Radio
} from "antd";

import moment from "moment";

import { SaveOutlined, ClearOutlined } from "@ant-design/icons";

import swal from "sweetalert";

import Hightchart2 from "./Highchart2";
import Piechart from "./Piechart";
import BarSCD from "./BarSCD";
import BarSCD2 from "./BarSCD2";

const { Option } = Select;

const Dashboard_s = prop => {
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  let xURL = "";
  let xlocation = window.location.hostname;

  // if (xlocation === "localhost") {
  //   xURL = "http://localhost:3002/api/";
  // } else {
  //   xURL = "https://research.rihes.cmu.ac.th/api/";
  // }

  xURL = "https://research.rihes.cmu.ac.th/api/";

  let YearNow = moment().format("YYYY");

  const [YearValue, _YearValue] = useState(YearNow);
  const [xYeardh, _xYeardh] = useState([]);
  const [xYeardh2, _xYeardh2] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);

  const [Kr12_old, _Kr12_old] = useState("");
  const [Kr13_old, _Kr13_old] = useState("");
  const [IntF_old, _IntF_old] = useState("");
  const [ThF_old, _ThF_old] = useState("");
  const [CmuF_old, _CmuF_old] = useState("");

  const [Num_Color1, _Num_Color1] = useState("red");
  const [Num_Color2, _Num_Color2] = useState("red");
  const [Num_Color3, _Num_Color3] = useState("red");
  const [Num_Color4, _Num_Color4] = useState("red");
  const [Num_Color5, _Num_Color5] = useState("red");

  const [data_Kr12, _data_Kr12] = useState();
  const [data_Kr13, _data_Kr13] = useState();
  const [data_IntF, _data_IntF] = useState();
  const [data_ThF, _data_ThF] = useState();
  const [data_CmuF, _data_CmuF] = useState();

  const [goal_Kr12, _goal_Kr12] = useState();
  const [goal_Kr13, _goal_Kr13] = useState();
  const [goal_IntF, _goal_IntF] = useState();
  const [goal_ThF, _goal_ThF] = useState();
  const [goal_CmuF, _goal_CmuF] = useState();

  const [dataSum_Kr12, _dataSum_Kr12] = useState();
  const [dataSum_Kr13, _dataSum_Kr13] = useState();
  const [dataSum_IntF, _dataSum_IntF] = useState();
  const [dataSum_ThF, _dataSum_ThF] = useState();
  const [dataSum_CmuF, _dataSum_CmuF] = useState();

  const [dataHigh1, _dataHigh1] = useState([]);
  const [dataHigh2, _dataHigh2] = useState([]);
  const [dataHigh3, _dataHigh3] = useState([]);
  const [dataHigh4, _dataHigh4] = useState([]);
  const [dataHigh5, _dataHigh5] = useState([]);

  const [dataBar_SCD, _dataBar_SCD] = useState([]);
  const [dataHigh_SCD, _dataHigh_SCD] = useState([]);
  const [dataHigh_SCD2, _dataHigh_SCD2] = useState([]);

  // const [dataBar_SCD2, _dataBar_SCD2] = useState([]);

  const [dataPie1, _dataPie1] = useState([]);
  const [dataPie2, _dataPie2] = useState([]);
  const [dataPie_SCD, _dataPie_SCD] = useState([]);

  let xFontsum = "17px";

  useEffect(() => {
    axios
      .get(xURL + "year_papers")
      .then(result => {
        //console.log(result.data);

        _xYeardh(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });

    axios
      .get(xURL + "year_papers2")
      .then(result => {
        //console.log(result.data);

        _xYeardh2(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });

    Find_scopus("S1", YearValue);
    Find_scopus("S2", YearValue);
    Find_scopus("S3", YearValue);
    Find_scopus("S4", YearValue);
    Find_scopus("S5", YearValue);

    Find_highData("S1", YearValue);
    Find_highData("S2", YearValue);
    Find_highData("S3", YearValue);
    Find_highData("S4", YearValue);
    Find_highData("S5", YearValue);
    Find_highData("SCD1", YearValue);
    Find_highData("SCD2", YearValue);

    Find_BarData("SCD1", YearValue);
    // Find_BarData2("SCD1", YearValue);

    Find_PieData("S1", YearValue);
    Find_PieData("S2", YearValue);
    Find_PieData("SCD1", YearValue);
  }, []);

  const handleChange = value => {
    // console.log(`selected ${value}`);
    Find_scopus("S1", value);
    Find_scopus("S2", value);
    Find_scopus("S3", value);
    Find_scopus("S4", value);
    Find_scopus("S5", value);

    Find_highData("S1", value);
    Find_highData("S2", value);
    Find_highData("S3", value);
    Find_highData("S4", value);
    Find_highData("S5", value);
    Find_highData("SCD1", value);
    Find_highData("SCD2", value);

    Find_BarData("SCD1", value);
    // Find_BarData2("SCD1", value);

    Find_PieData("S1", value);
    Find_PieData("S2", value);
    Find_PieData("SCD1", value);

    _YearValue(value);
  };

  const handleChange2 = value => {
    // console.log(`selected ${value}`);
    Find_scopus2("S11", value);
    Find_scopus2("S12", value);

    Find_highData2("S11", value);
    Find_highData2("S12", value);
    Find_highData2("SCD1", value);
    Find_highData2("SCD2", value);

    Find_BarData("SCD2", value);
    // Find_BarData2("SCD2", value);

    Find_PieData2("S11", value);
    Find_PieData2("S12", value);
    Find_PieData2("SCD2", value);
    // _YearValue(value);
  };

  const bClearclick = () => {
    form1.resetFields();

    findGoal();
  };

  const bSaveclick = () => {
    const f = form1.getFieldsValue();

    if (!f.ipKr12) {
      swal(
        "บันทึกไม่ได้!",
        "ยังไม่ได้กรอก [KR11] ทุนวิจัย (ล้านบาท/ปี) (Goal)!",
        "warning"
      );
    } else if (!f.ipKr13) {
      swal(
        "บันทึกไม่ได้!",
        "ยังไม่ได้กรอก [KR12] รายได้นอกเหนือจากทุนวิจัย (ล้านบาท/ปี) (Goal)!",
        "warning"
      );
    } else {
      // else if (!f.ipIntF) {
      //   swal("Save Error!", "Data entry fields Int. funding (Goal)!", "warning");
      // } else if (!f.ipThF) {
      //   swal("Save Error!", "Data entry fields Thai. funding (Goal)!", "warning");
      // } else if (!f.ipCmuF) {
      //   swal("Save Error!", "Data entry fields CMU funding (Goal)!", "warning");
      // }
      swal({
        title: "Confirm Edit Goal",
        text: "Year " + YearValue,
        icon: "warning",
        buttons: ["Cancle", "Ok"]
      }).then(willOk => {
        if (willOk) {
          updatedata();
        }
      });
    }
  };

  const updatedata = () => {
    const f = form1.getFieldsValue();

    let xdata = [
      { name: "KR12 Total Research Funding", goal: f.ipKr12, old: Kr12_old },
      { name: "KR13 Other Income", goal: f.ipKr13, old: Kr13_old }
      // { name: "Int. funding", goal: f.ipIntF, old: IntF_old },
      // { name: "Thai. funding", goal: f.ipThF, old: ThF_old },
      // { name: "CMU funding", goal: f.ipCmuF, old: CmuF_old }
    ];

    // console.log(emplydata);

    xdata.forEach((i, idx) => {
      if (!i.old) {
        axios
          .post(xURL + "insert_goal", {
            year: YearValue,
            name: i.name,
            goal: i.goal
          })
          .then(result => {
            swal("Save Complete!", "", "success");
            setModalOpen(false);

            // console.log(result.data);

            Find_scopus("S1", YearValue);
            Find_scopus("S2", YearValue);
            Find_scopus("S3", YearValue);
            Find_scopus("S4", YearValue);
            Find_scopus("S5", YearValue);

            Find_highData("S1", YearValue);
            Find_highData("S2", YearValue);
            Find_highData("S3", YearValue);
            Find_highData("S4", YearValue);
            Find_highData("S5", YearValue);
            Find_highData("SCD1", YearValue);
            Find_highData("SCD2", YearValue);

            Find_BarData("SCD1", YearValue);
            // Find_BarData2("SCD1", YearValue);

            Find_PieData("S1", YearValue);
            Find_PieData("S2", YearValue);
            Find_PieData("SCD1", YearValue);
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      } else {
        axios
          .post(xURL + "update_goal", {
            year: YearValue,
            name: i.name,
            goal: i.goal
          })
          .then(result => {
            swal("Save Complete!", "", "success");
            setModalOpen(false);

            // console.log(result.data);

            Find_scopus("S1", YearValue);
            Find_scopus("S2", YearValue);
            Find_scopus("S3", YearValue);
            Find_scopus("S4", YearValue);
            Find_scopus("S5", YearValue);

            Find_highData("S1", YearValue);
            Find_highData("S2", YearValue);
            Find_highData("S3", YearValue);
            Find_highData("S4", YearValue);
            Find_highData("S5", YearValue);
            Find_highData("SCD1", YearValue);
            Find_highData("SCD2", YearValue);

            Find_BarData("SCD1", YearValue);
            // Find_BarData2("SCD1", YearValue);

            Find_PieData("S1", YearValue);
            Find_PieData("S2", YearValue);
            Find_PieData("SCD1", YearValue);
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      }
    });
  };

  const findGoal = () => {
    _Kr12_old("");
    _Kr13_old("");
    _IntF_old("");
    _ThF_old("");
    _CmuF_old("");

    axios
      .post(xURL + "db_findGoal", { year: YearValue })
      .then(result => {
        // console.log("data", result.data);

        result.data.forEach((i, idx) => {
          if (i.topic == "KR12 Total Research Funding") {
            form1.setFieldsValue({
              ipKr12: i.goal
            });

            _Kr12_old(i.goal);
          } else if (i.topic == "KR13 Other Income") {
            form1.setFieldsValue({
              ipKr13: i.goal
            });

            _Kr13_old(i.goal);
          } else if (i.topic == "Int. funding") {
            form1.setFieldsValue({
              ipIntF: i.goal
            });

            _IntF_old(i.goal);
          } else if (i.topic == "Thai. funding") {
            form1.setFieldsValue({
              ipThF: i.goal
            });

            _ThF_old(i.goal);
          } else if (i.topic == "CMU funding") {
            form1.setFieldsValue({
              ipCmuF: i.goal
            });

            _CmuF_old(i.goal);
          }
        });
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_scopus = (order, YearValue) => {
    axios
      .post(xURL + "db_tabbox", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        if (result.data[0]) {
          if (order == "S1") {
            _data_Kr12(result.data[0].pub_data);
            _goal_Kr12(result.data[0].goal);
            _dataSum_Kr12(
              result.data[0].total_receive.toLocaleString(undefined, {
                minimumFractionDigits: 2
              })
            );

            const percentage =
              parseFloat(result.data[0].pub_data2) /
              parseFloat(result.data[0].goal) *
              100;

            if (percentage < 50) {
              _Num_Color1("red");
            } else if (percentage < 80) {
              _Num_Color1("#FFA500"); // เหลือง
            } else {
              _Num_Color1("green");
            }

            // if (
            //   parseFloat(result.data[0].pub_data2) >=
            //   parseFloat(result.data[0].goal)
            // ) {
            //   _Num_Color1("green");
            // } else {
            //   _Num_Color1("red");
            // }
          } else if (order == "S2") {
            _data_Kr13(result.data[0].pub_data);
            _goal_Kr13(result.data[0].goal);
            _dataSum_Kr13(
              result.data[0].amount.toLocaleString(undefined, {
                minimumFractionDigits: 2
              })
            );

            const percentage =
              parseFloat(result.data[0].pub_data2) /
              parseFloat(result.data[0].goal) *
              100;

            if (percentage < 50) {
              _Num_Color2("red");
            } else if (percentage < 80) {
              _Num_Color2("#FFA500"); // เหลือง
            } else {
              _Num_Color2("green");
            }

            // if (
            //   parseFloat(result.data[0].pub_data2) >=
            //   parseFloat(result.data[0].goal)
            // ) {
            //   _Num_Color2("green");
            // } else {
            //   _Num_Color2("red");
            // }
          } else if (order == "S3") {
            _data_IntF(result.data[0].pub_data);
            _goal_IntF(result.data[0].goal);
            _dataSum_IntF(
              result.data[0].total_receive.toLocaleString(undefined, {
                minimumFractionDigits: 2
              })
            );

            if (
              parseFloat(result.data[0].pub_data2) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color3("green");
            } else {
              _Num_Color3("red");
            }
          } else if (order == "S4") {
            _data_ThF(result.data[0].pub_data);
            _goal_ThF(result.data[0].goal);
            _dataSum_ThF(
              result.data[0].total_receive.toLocaleString(undefined, {
                minimumFractionDigits: 2
              })
            );

            if (
              parseFloat(result.data[0].pub_data2) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color4("green");
            } else {
              _Num_Color4("red");
            }
          } else if (order == "S5") {
            _data_CmuF(result.data[0].pub_data);
            _goal_CmuF(result.data[0].goal);
            _dataSum_CmuF(
              result.data[0].total_receive.toLocaleString(undefined, {
                minimumFractionDigits: 2
              })
            );

            if (
              parseFloat(result.data[0].pub_data2) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color5("green");
            } else {
              _Num_Color5("red");
            }
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_scopus2 = (order, YearValue) => {
    axios
      .post(xURL + "db_tabbox2", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        if (result.data[0]) {
          if (order == "S11") {
            _data_Kr12(result.data[0].pub_data);
            _goal_Kr12(result.data[0].goal);
            _dataSum_Kr12(
              result.data[0].total_receive.toLocaleString(undefined, {
                minimumFractionDigits: 2
              })
            );

            const percentage =
              parseFloat(result.data[0].pub_data2) /
              parseFloat(result.data[0].goal) *
              100;

            if (percentage < 50) {
              _Num_Color1("red");
            } else if (percentage < 80) {
              _Num_Color1("#FFA500"); // เหลือง
            } else {
              _Num_Color1("green");
            }

            // if (
            //   parseFloat(result.data[0].pub_data2) >=
            //   parseFloat(result.data[0].goal)
            // ) {
            //   _Num_Color1("green");
            // } else {
            //   _Num_Color1("red");
            // }
          } else if (order == "S12") {
            _data_Kr13(result.data[0].pub_data);
            _goal_Kr13(result.data[0].goal);
            _dataSum_Kr13(
              result.data[0].amount.toLocaleString(undefined, {
                minimumFractionDigits: 2
              })
            );

            const percentage =
              parseFloat(result.data[0].pub_data2) /
              parseFloat(result.data[0].goal) *
              100;

            if (percentage < 50) {
              _Num_Color2("red");
            } else if (percentage < 80) {
              _Num_Color2("#FFA500"); // เหลือง
            } else {
              _Num_Color2("green");
            }

            // if (
            //   parseFloat(result.data[0].pub_data2) >=
            //   parseFloat(result.data[0].goal)
            // ) {
            //   _Num_Color2("green");
            // } else {
            //   _Num_Color2("red");
            // }
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_highData = (order, YearValue) => {
    axios
      .post(xURL + "db_Highdata2", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        let Tb1 = [];

        let xsum = 0;

        let xgoal12 = 0,
          xgoal11 = 0,
          xgoal10 = 0,
          xgoal9 = 0,
          xgoal8 = 0,
          xgoal7 = 0,
          xgoal6 = 0,
          xgoal5 = 0,
          xgoal4 = 0,
          xgoal3 = 0,
          xgoal2 = 0,
          xgoal1 = 0;

        xgoal12 = parseFloat(result.data[0].goal).toFixed(1);
        xgoal11 = parseFloat(xgoal12 - xgoal12 / 12).toFixed(1);
        xgoal10 = parseFloat(xgoal11 - xgoal12 / 12).toFixed(1);
        xgoal9 = parseFloat(xgoal10 - xgoal12 / 12).toFixed(1);
        xgoal8 = parseFloat(xgoal9 - xgoal12 / 12).toFixed(1);
        xgoal7 = parseFloat(xgoal8 - xgoal12 / 12).toFixed(1);
        xgoal6 = parseFloat(xgoal7 - xgoal12 / 12).toFixed(1);
        xgoal5 = parseFloat(xgoal6 - xgoal12 / 12).toFixed(1);
        xgoal4 = parseFloat(xgoal5 - xgoal12 / 12).toFixed(1);
        xgoal3 = parseFloat(xgoal4 - xgoal12 / 12).toFixed(1);
        xgoal2 = parseFloat(xgoal3 - xgoal12 / 12).toFixed(1);
        xgoal1 = parseFloat(xgoal2 - xgoal12 / 12).toFixed(1);

        if (result.data[0]) {
          if (YearValue.toString() == moment().format("YYYY")) {
            // console.log(parseInt(moment().format("MM")));
            let currentMonth = parseInt(moment().format("MM")); // เดือนปัจจุบัน (1-12)
            xsum = 0;

            for (let i = 1; i <= 12; i++) {
              let monthKey = `m${i}`;
              let goalKey = `xgoal${i}`; // ตัวแปร goal สำหรับแต่ละเดือน

              if (i <= currentMonth) {
                xsum += result.data[0][monthKey];

                Tb1.push({
                  name: i.toString(),
                  data_in_Month: result.data[0][monthKey],
                  data: xsum.toFixed(2),
                  goal: eval(goalKey) // ใช้ eval เพื่อดึงค่าจากตัวแปร xgoal1, xgoal2, ...
                });
              } else {
                Tb1.push({
                  name: i.toString(),
                  data_in_Month: result.data[0][monthKey],
                  goal: eval(goalKey) // ใช้ eval เพื่อดึงค่าจากตัวแปร xgoal1, xgoal2, ...
                });
              }
            }
          } else {
            // 👉 ไม่ใช่ปีปัจจุบัน
            xsum = 0;
            for (let i = 1; i <= 12; i++) {
              const monthKey = `m${i}`;
              const goalKey = eval(`xgoal${i}`); // หรือใช้ goals[i] ถ้าเตรียม object ไว้แล้ว

              xsum += result.data[0][monthKey];

              Tb1.push({
                name: i.toString(),
                data_in_Month: parseFloat(result.data[0][monthKey]).toFixed(2),
                data: parseFloat(xsum).toFixed(2),
                goal: goalKey
              });
            }
          }
        }

        if (order == "S1") {
          _dataHigh1(Tb1);
        } else if (order == "S2") {
          _dataHigh2(Tb1);
        } else if (order == "S3") {
          _dataHigh3(Tb1);
        } else if (order == "S4") {
          _dataHigh4(Tb1);
        } else if (order == "S5") {
          _dataHigh5(Tb1);
        } else if (order == "SCD1") {
          _dataHigh_SCD(Tb1);
        } else if (order == "SCD2") {
          _dataHigh_SCD2(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_highData2 = (order, YearValue) => {
    axios
      .post(xURL + "db_Highdata2_1", {
        order: order,
        year: YearValue,
        yearrub: parseInt(YearValue) - 1,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        let Tb1 = [];

        let xsum = 0;

        let xgoal12 = 0,
          xgoal11 = 0,
          xgoal10 = 0,
          xgoal9 = 0,
          xgoal8 = 0,
          xgoal7 = 0,
          xgoal6 = 0,
          xgoal5 = 0,
          xgoal4 = 0,
          xgoal3 = 0,
          xgoal2 = 0,
          xgoal1 = 0;

        xgoal12 = parseFloat(result.data[0].goal).toFixed(1);
        xgoal11 = parseFloat(xgoal12 - xgoal12 / 12).toFixed(1);
        xgoal10 = parseFloat(xgoal11 - xgoal12 / 12).toFixed(1);
        xgoal9 = parseFloat(xgoal10 - xgoal12 / 12).toFixed(1);
        xgoal8 = parseFloat(xgoal9 - xgoal12 / 12).toFixed(1);
        xgoal7 = parseFloat(xgoal8 - xgoal12 / 12).toFixed(1);
        xgoal6 = parseFloat(xgoal7 - xgoal12 / 12).toFixed(1);
        xgoal5 = parseFloat(xgoal6 - xgoal12 / 12).toFixed(1);
        xgoal4 = parseFloat(xgoal5 - xgoal12 / 12).toFixed(1);
        xgoal3 = parseFloat(xgoal4 - xgoal12 / 12).toFixed(1);
        xgoal2 = parseFloat(xgoal3 - xgoal12 / 12).toFixed(1);
        xgoal1 = parseFloat(xgoal2 - xgoal12 / 12).toFixed(1);

        if (result.data[0]) {
          xsum = result.data[0].m1;
          Tb1.push({
            name: "10/" + (parseInt(YearValue) - 1).toString(),
            data_in_Month: result.data[0].m1,
            data: xsum.toFixed(2),
            goal: xgoal1
          });

          xsum = xsum + result.data[0].m2;
          Tb1.push({
            name: "11/" + (parseInt(YearValue) - 1).toString(),
            data_in_Month: result.data[0].m2,
            data: xsum.toFixed(2),
            goal: xgoal2
          });

          xsum = xsum + result.data[0].m3;
          Tb1.push({
            name: "12/" + (parseInt(YearValue) - 1).toString(),
            data_in_Month: result.data[0].m3,
            data: xsum.toFixed(2),
            goal: xgoal3
          });

          xsum = xsum + result.data[0].m4;
          Tb1.push({
            name: "1/" + YearValue.toString(),
            data_in_Month: result.data[0].m4,
            data: xsum.toFixed(2),
            goal: xgoal4
          });

          xsum = xsum + result.data[0].m5;
          Tb1.push({
            name: "2/" + YearValue.toString(),
            data_in_Month: result.data[0].m5,
            data: xsum.toFixed(2),
            goal: xgoal5
          });

          xsum = xsum + result.data[0].m6;
          Tb1.push({
            name: "3/" + YearValue.toString(),
            data_in_Month: result.data[0].m6,
            data: xsum.toFixed(2),
            goal: xgoal6
          });

          xsum = xsum + result.data[0].m7;
          Tb1.push({
            name: "4/" + YearValue.toString(),
            data_in_Month: result.data[0].m7,
            data: xsum.toFixed(2),
            goal: xgoal7
          });

          xsum = xsum + result.data[0].m8;
          Tb1.push({
            name: "5/" + YearValue.toString(),
            data_in_Month: result.data[0].m8,
            data: xsum.toFixed(2),
            goal: xgoal8
          });

          xsum = xsum + result.data[0].m9;
          Tb1.push({
            name: "6/" + YearValue.toString(),
            data_in_Month: result.data[0].m9,
            data: xsum.toFixed(2),
            goal: xgoal9
          });

          xsum = xsum + result.data[0].m10;
          Tb1.push({
            name: "7/" + YearValue.toString(),
            data_in_Month: result.data[0].m10,
            data: xsum.toFixed(2),
            goal: xgoal10
          });

          xsum = xsum + result.data[0].m11;
          Tb1.push({
            name: "8/" + YearValue.toString(),
            data_in_Month: result.data[0].m11,
            data: xsum.toFixed(2),
            goal: xgoal11
          });

          xsum = xsum + result.data[0].m12;
          Tb1.push({
            name: "9/" + YearValue.toString(),
            data_in_Month: result.data[0].m12,
            data: xsum.toFixed(2),
            goal: result.data[0].goal
          });
        }

        if (order == "S11") {
          _dataHigh1(Tb1);
        } else if (order == "S12") {
          _dataHigh2(Tb1);
        } else if (order == "SCD1") {
          _dataHigh_SCD(Tb1);
        } else if (order == "SCD2") {
          _dataHigh_SCD2(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_BarData = (order, YearValue) => {
    axios
      .post(xURL + "db_Bardata", {
        order: order,
        year: YearValue
      })
      .then(result => {
        let Tb1 = [];
        if (result.data && result.data.length > 0) {
          result.data.forEach(row => {
            let xname = "";
            if (row.project_clinic == "0") xname = "ไม่ระบุ";
            else if (row.project_clinic == "1") xname = "Health Care Clinic";
            else if (row.project_clinic == "2") xname = "Family Clinic";
            else if (row.project_clinic == "3") xname = "PIMAN Clinic";
            else if (row.project_clinic == "รวมทั้งหมด") xname = "รวมทั้งหมด";

            Tb1.push({
              name: xname,
              value: Number(row.total_receive)
            });
          });
        }

        _dataBar_SCD(Tb1);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  // const Find_BarData2 = (order, YearValue) => {
  //   axios
  //     .post(xURL + "db_Bardata2", {
  //       order: order,
  //       year: YearValue
  //     })
  //     .then(result => {
  //       if (!result.data || result.data.length === 0) {
  //         _dataBar_SCD2([]);
  //         return;
  //       }

  //       const monthList = [
  //         { key: "m1", label: "1" },
  //         { key: "m2", label: "2" },
  //         { key: "m3", label: "3" },
  //         { key: "m4", label: "4" },
  //         { key: "m5", label: "5" },
  //         { key: "m6", label: "6" },
  //         { key: "m7", label: "7" },
  //         { key: "m8", label: "8" },
  //         { key: "m9", label: "9" },
  //         { key: "m10", label: "10" },
  //         { key: "m11", label: "11" },
  //         { key: "m12", label: "12" }
  //       ];

  //       const Tb1 = monthList.map(m => {
  //         const row = { month: m.label };
  //         result.data.forEach(r => {
  //           row[r.project_clinic] = Number(r[m.key] || 0); // แปลงเป็น number
  //         });
  //         return row;
  //       });

  //       _dataBar_SCD2(Tb1);
  //     })
  //     .catch(function(error) {
  //       // handle error
  //       console.log("problem here", error);
  //     });
  // };

  const Find_PieData = (order, YearValue) => {
    axios
      .post(xURL + "db_Piedata2", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        let Tb1 = [];
        if (result.data[0]) {
          if (order == "S1") {
            Tb1.push({
              name: "Int. fund",
              value: result.data[0].int_fund,
              value2:
                (result.data[0].int_fundCount / 1000000).toFixed(2) + " MB"
            });
            Tb1.push({
              name: "CMU fund",
              value: result.data[0].cmu_fund,
              value2:
                (result.data[0].cmu_fundCount / 1000000).toFixed(2) + " MB"
            });
            Tb1.push({
              name: "Thai fund",
              value: result.data[0].thai_fund,
              value2:
                (result.data[0].thai_fundCount / 1000000).toFixed(2) + " MB"
            });

            _dataPie1(Tb1);
          } else if (order == "S2") {
            // Tb1.push({
            //   name: "Clinic",
            //   value: result.data[0].idsu,
            //   value2: result.data[0].idsuCount + " MB"
            // });
            // Tb1.push({
            //   name: "NINE",
            //   value: result.data[0].nine,
            //   value2: result.data[0].nineCount + " MB"
            // });
            // Tb1.push({
            //   name: "CMBID",
            //   value: result.data[0].cmbid,
            //   value2: result.data[0].cmbidCount + " MB"
            // });
            // Tb1.push({
            //   name: "RSO",
            //   value: result.data[0].rso,
            //   value2: result.data[0].rsoCount + " MB"
            // });
            // Tb1.push({
            //   name: "SHSR",
            //   value: result.data[0].shsr,
            //   value2: result.data[0].shsrCount + " MB"
            // });

            Tb1.push({
              name: "Clinic",
              value: result.data[0].clinic,
              value2: result.data[0].clinicCount + " MB"
            });
            Tb1.push({
              name: "สำนักวิชาฯ",
              value: result.data[0].shsr2,
              value2: result.data[0].shsrCount2 + " MB"
            });
            Tb1.push({
              name: "ห้องปฏิบัติการ",
              value: result.data[0].lab,
              value2: result.data[0].labCount + " MB"
            });
            Tb1.push({
              name: "GI/NUTRI",
              value: result.data[0].nutri,
              value2: result.data[0].nutriCount + " MB"
            });
            Tb1.push({
              name: "อื่นๆ",
              value: result.data[0].other,
              value2: result.data[0].otherCount + " MB"
            });

            _dataPie2(Tb1);
          } else if (order == "SCD1") {
            Tb1.push({
              name: "Health Care Clinic",
              value: result.data[0].hcc,
              value2: result.data[0].hccCount + " MB"
            });
            Tb1.push({
              name: "Family Clinic",
              value: result.data[0].fc,
              value2: result.data[0].fcCount + " MB"
            });
            Tb1.push({
              name: "PIMAN Clinic",
              value: result.data[0].pmc,
              value2: result.data[0].pmcCount + " MB"
            });
            Tb1.push({
              name: "ไม่ระบุ",
              value: result.data[0].nspcf,
              value2: result.data[0].nspcfCount + " MB"
            });

            _dataPie_SCD(Tb1);
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_PieData2 = (order, YearValue) => {
    axios
      .post(xURL + "db_Piedata2_1", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        let Tb1 = [];
        if (result.data[0]) {
          if (order == "S11") {
            Tb1.push({
              name: "Int. fund",
              value: result.data[0].int_fund,
              value2:
                (result.data[0].int_fundCount / 1000000).toFixed(2) + " MB"
            });
            Tb1.push({
              name: "CMU fund",
              value: result.data[0].cmu_fund,
              value2:
                (result.data[0].cmu_fundCount / 1000000).toFixed(2) + " MB"
            });
            Tb1.push({
              name: "Thai fund",
              value: result.data[0].thai_fund,
              value2:
                (result.data[0].thai_fundCount / 1000000).toFixed(2) + " MB"
            });

            _dataPie1(Tb1);
          } else if (order == "S12") {
            // Tb1.push({
            //   name: "Clinic",
            //   value: result.data[0].idsu,
            //   value2: result.data[0].idsuCount + " MB"
            // });
            // Tb1.push({
            //   name: "NINE",
            //   value: result.data[0].nine,
            //   value2: result.data[0].nineCount + " MB"
            // });
            // Tb1.push({
            //   name: "CMBID",
            //   value: result.data[0].cmbid,
            //   value2: result.data[0].cmbidCount + " MB"
            // });
            // Tb1.push({
            //   name: "RSO",
            //   value: result.data[0].rso,
            //   value2: result.data[0].rsoCount + " MB"
            // });
            // Tb1.push({
            //   name: "SHSR",
            //   value: result.data[0].shsr,
            //   value2: result.data[0].shsrCount + " MB"
            // });

            Tb1.push({
              name: "Clinic",
              value: result.data[0].clinic,
              value2: result.data[0].clinicCount + " MB"
            });
            Tb1.push({
              name: "สำนักวิชาฯ",
              value: result.data[0].shsr2,
              value2: result.data[0].shsrCount2 + " MB"
            });
            Tb1.push({
              name: "ห้องปฏิบัติการ",
              value: result.data[0].lab,
              value2: result.data[0].labCount + " MB"
            });
            Tb1.push({
              name: "GI/NUTRI",
              value: result.data[0].nutri,
              value2: result.data[0].nutriCount + " MB"
            });
            Tb1.push({
              name: "อื่นๆ",
              value: result.data[0].other,
              value2: result.data[0].otherCount + " MB"
            });

            _dataPie2(Tb1);
          } else if (order == "SCD2") {
            Tb1.push({
              name: "Health Care Clinic",
              value: result.data[0].hcc,
              value2: result.data[0].hccCount + " MB"
            });
            Tb1.push({
              name: "Family Clinic",
              value: result.data[0].fc,
              value2: result.data[0].fcCount + " MB"
            });
            Tb1.push({
              name: "PIMAN Clinic",
              value: result.data[0].pmc,
              value2: result.data[0].pmcCount + " MB"
            });
            Tb1.push({
              name: "ไม่ระบุ",
              value: result.data[0].nspcf,
              value2: result.data[0].nspcfCount + " MB"
            });

            _dataPie_SCD(Tb1);
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const [value1, setValue1] = useState(1);

  const onChange1 = e => {
    const newValue = e.target.value;
    setValue1(newValue);

    // หา array ที่จะใช้
    const arr = newValue === 1 ? xYeardh : xYeardh2;

    if (arr.length > 0) {
      const firstYear = arr[0].year; // ได้ค่าชัดเจนแน่นอน
      // เซตค่า slyear เป็น element แรก (index 0)
      form2.setFieldsValue({
        slyear: arr[0].year
      });

      if (newValue === 1) {
        Find_scopus("S1", firstYear);
        Find_scopus("S2", firstYear);
        Find_scopus("S3", firstYear);
        Find_scopus("S4", firstYear);
        Find_scopus("S5", firstYear);

        Find_highData("S1", firstYear);
        Find_highData("S2", firstYear);
        Find_highData("S3", firstYear);
        Find_highData("S4", firstYear);
        Find_highData("S5", firstYear);
        Find_highData("SCD1", firstYear);
        Find_highData("SCD2", firstYear);

        Find_BarData("SCD1", firstYear);
        // Find_BarData2("SCD1", firstYear);

        Find_PieData("S1", firstYear);
        Find_PieData("S2", firstYear);
        Find_PieData("SCD1", firstYear);
      } else if (newValue === 2) {
        Find_scopus2("S11", firstYear);
        Find_scopus2("S12", firstYear);

        Find_highData2("S11", firstYear);
        Find_highData2("S12", firstYear);
        Find_highData2("SCD1", firstYear);
        Find_highData2("SCD2", firstYear);

        Find_BarData("SCD2", firstYear);
        // Find_BarData2("SCD2", firstYear);

        Find_PieData2("S11", firstYear);
        Find_PieData2("S12", firstYear);
        Find_PieData2("SCD2", firstYear);
      }
    }
  };

  return (
    <React.Fragment>
      <div>
        <h1 className="rise">Sustainable growth</h1>
      </div>

      <Form form={form2} initialValues={{ slyear: YearNow }}>
        <Row style={{ marginBottom: "10px" }}>
          <Radio.Group
            value={value1}
            onChange={onChange1}
            options={[
              { value: 1, label: "ปีปฏิทิน" },
              { value: 2, label: "ปีงบประมาณ" }
            ]}
          />
        </Row>

        <Row>
          <div>
            <Form.Item label="Year" name="slyear">
              <Select
                style={{ width: 250, marginBottom: "20px" }}
                onChange={value1 === 1 ? handleChange : handleChange2}
              >
                {(value1 === 1 ? xYeardh : xYeardh2).map((i, idx) =>
                  <Option key={idx} value={i.year}>
                    {i.year} ({i.name})
                  </Option>
                )}
              </Select>
            </Form.Item>
          </div>

          {prop.level == 0
            ? <div style={{ marginLeft: "25px" }}>
                <Button
                  type="primary"
                  onClick={() => {
                    form1.resetFields();

                    findGoal();

                    setModalOpen(true);
                  }}
                >
                  Edit Goal
                </Button>
              </div>
            : <div />}
        </Row>
      </Form>

      <Row gutter={3}>
        <Col xs={23} sm={12} md={12} lg={12} xl={12}>
          <Card style={{ height: 155, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  [KR11] ทุนวิจัย (ล้านบาท/ปี)
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <Col span={18}>
                    <p
                      style={{
                        fontWeight: "bold",
                        marginRight: "20px",
                        marginTop: "12px",
                        fontSize: "40px",
                        color: Num_Color1
                      }}
                    >
                      {data_Kr12}
                    </p>
                  </Col>
                  <Col span={3}>
                    <p
                      style={{
                        fontWeight: "bold",
                        // marginRight: "20px",
                        marginLeft: "7px",
                        marginTop: "40px",
                        fontSize: "16px"
                      }}
                    >
                      %
                    </p>
                  </Col>
                </Row>
              </Col>

              <Col span={6} style={{ background: "#1679AB", height: "135px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_Kr12}
                </p>
              </Col>
            </Row>

            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6",
                  fontSize: xFontsum
                }}
              >
                ({dataSum_Kr12}) บาท
              </p>
            </Row>
          </Card>
        </Col>
        <Col xs={23} sm={12} md={12} lg={12} xl={12}>
          <Card style={{ height: 155, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  [KR12] รายได้นอกเหนือจากทุนวิจัย (ล้านบาท/ปี)
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <Col span={18}>
                    <p
                      style={{
                        fontWeight: "bold",
                        marginRight: "20px",
                        marginTop: "12px",
                        fontSize: "40px",
                        color: Num_Color2
                      }}
                    >
                      {data_Kr13}
                    </p>
                  </Col>
                  <Col span={3}>
                    <p
                      style={{
                        fontWeight: "bold",
                        // marginRight: "20px",
                        marginLeft: "7px",
                        marginTop: "40px",
                        fontSize: "16px"
                      }}
                    >
                      %
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "135px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_Kr13}
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6",
                  fontSize: xFontsum
                }}
              >
                ({dataSum_Kr13}) บาท
              </p>
            </Row>
          </Card>
        </Col>
        {/* <Col xs={23} sm={12} md={12} lg={8} xl={4}>
          <Card style={{ height: 140, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  Int. funding
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <Col span={18}>
                    <p
                      style={{
                        fontWeight: "bold",
                        marginRight: "20px",
                        marginTop: "12px",
                        fontSize: "40px",
                        color: Num_Color3
                      }}
                    >
                      {data_IntF}
                    </p>
                  </Col>
                  <Col span={3}>
                    <p
                      style={{
                        fontWeight: "bold",
                        // marginRight: "20px",
                        marginLeft: "7px",
                        marginTop: "40px",
                        fontSize: "16px"
                      }}
                    >
                      %
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "120px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_IntF}
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6"
                }}
              >
                ({dataSum_IntF})
              </p>
            </Row>
          </Card>
        </Col>
        <Col xs={23} sm={12} md={12} lg={8} xl={4}>
          <Card style={{ height: 140, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  Thai. funding
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <Col span={18}>
                    <p
                      style={{
                        fontWeight: "bold",
                        marginRight: "20px",
                        marginTop: "12px",
                        fontSize: "40px",
                        color: Num_Color4
                      }}
                    >
                      {data_ThF}
                    </p>
                  </Col>
                  <Col span={3}>
                    <p
                      style={{
                        fontWeight: "bold",
                        // marginRight: "20px",
                        marginLeft: "7px",
                        marginTop: "40px",
                        fontSize: "16px"
                      }}
                    >
                      %
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "120px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_ThF}
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6"
                }}
              >
                ({dataSum_ThF})
              </p>
            </Row>
          </Card>
        </Col>
        <Col xs={23} sm={12} md={12} lg={8} xl={4}>
          <Card style={{ height: 140, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  CMU funding
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <Col span={18}>
                    <p
                      style={{
                        fontWeight: "bold",
                        marginRight: "20px",
                        marginTop: "12px",
                        fontSize: "40px",
                        color: Num_Color5
                      }}
                    >
                      {data_CmuF}
                    </p>
                  </Col>
                  <Col span={3}>
                    <p
                      style={{
                        fontWeight: "bold",
                        // marginRight: "20px",
                        marginLeft: "7px",
                        marginTop: "40px",
                        fontSize: "16px"
                      }}
                    >
                      %
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "120px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_CmuF}
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6"
                }}
              >
                ({dataSum_CmuF})
              </p>
            </Row>
          </Card>
        </Col> */}
      </Row>

      <div style={{ height: "10px" }} />

      <Row gutter={16}>
        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 300 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              [KR11] ทุนวิจัย (ล้านบาท/ปี)
            </p>
            <Hightchart2 dataHigh={dataHigh1} order={1} />
          </Card>
        </Col>
        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 300 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              [KR12] รายได้นอกเหนือจากทุนวิจัย (ล้านบาท/ปี)
            </p>
            <Hightchart2 dataHigh={dataHigh2} order={1} />
          </Card>
        </Col>
        {/* <Col xs={23} sm={23} md={12} lg={12} xl={8}>
          <Card style={{ height: 280 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              Int. funding
            </p>
            <Hightchart2 dataHigh={dataHigh3} order={1} />
          </Card>
        </Col> */}
      </Row>

      {/* <div style={{ height: "10px" }} /> */}

      {/* <Row gutter={16}>
        <Col xs={23} sm={23} md={12} lg={12} xl={12}>
          <Card style={{ height: 280 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              Thai. funding
            </p>
            <Hightchart2 dataHigh={dataHigh4} order={1} />
          </Card>
        </Col>

        <Col xs={23} sm={23} md={12} lg={12} xl={12}>
          <Card style={{ height: 280 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              CMU funding
            </p>
            <Hightchart2 dataHigh={dataHigh5} order={1} />
          </Card>
        </Col>
      </Row> */}

      <div style={{ height: "10px" }} />

      <Row gutter={16}>
        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 320 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              % [KR11] ทุนวิจัย (ล้านบาท/ปี)
            </p>

            <Piechart dataPie={dataPie1} />
          </Card>
        </Col>
        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 320 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              % [KR12] รายได้นอกเหนือจากทุนวิจัย (ล้านบาท/ปี)
            </p>

            <Piechart dataPie={dataPie2} />
          </Card>
        </Col>
      </Row>

      <div style={{ height: "10px" }} />

      <Row gutter={16}>
        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 320 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              ทุนวิจัยบริษัทยา (ล้านบาท/ปี)
            </p>

            <BarSCD dataBar={dataBar_SCD} />
          </Card>
        </Col>
        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 320 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              % ทุนวิจัยบริษัทยา (ล้านบาท/ปี)
            </p>

            <Piechart dataPie={dataPie_SCD} />
          </Card>
        </Col>
      </Row>

      <div style={{ height: "10px" }} />

      <Row gutter={16}>
        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 320 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              ทุนวิจัยบริษัทยา (ล้านบาท/ปี)
            </p>

            {/* <BarSCD2 dataBar={dataBar_SCD2} /> */}

            <Hightchart2 dataHigh={dataHigh_SCD} order={1} datatype="unlimit" />
          </Card>
        </Col>
        <Col xs={23} sm={23} md={23} lg={12} xl={12}>
          <Card style={{ height: 320 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              ทุนบริการวิชาการ (ล้านบาท/ปี)
            </p>

            <Hightchart2 dataHigh={dataHigh_SCD2} order={1} />
          </Card>
        </Col>
      </Row>

      <div style={{ height: "50px" }} />

      <Modal
        title="Edit Goal"
        centered
        visible={modalOpen}
        onOk={() => setModalOpen(false)}
        onCancel={() => setModalOpen(false)}
        footer={null}
        width={1000}
      >
        <p style={{ fontWeight: "bold", fontSize: "18px" }}>
          Year {YearValue}
        </p>
        <hr className="style-two" style={{ marginBottom: "20px" }} />

        <Form form={form1} initialValues={{}}>
          <Row>
            <Col span={6}>
              <p className="t-goal">[KR11] ทุนวิจัย (ล้านบาท/ปี)</p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr12">
                  <InputNumber
                    autoFocus
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <p className="t-goal">
                [KR12] รายได้นอกเหนือจากทุนวิจัย (ล้านบาท/ปี)
              </p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr13">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          {/* <Row>
            <Col span={4}>
              <p className="t-goal">Int. funding</p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipIntF">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <p className="t-goal">Thai. funding</p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipThF">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <p className="t-goal">CMU funding</p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipCmuF">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row> */}
        </Form>

        <hr className="style-two" style={{ marginBottom: "20px" }} />

        <Row justify="center">
          <Space>
            <Button
              type="primary"
              onClick={() => {
                bSaveclick();
              }}
            >
              <SaveOutlined /> Save
            </Button>

            <Button
              type="danger"
              onClick={() => {
                bClearclick();
              }}
            >
              <ClearOutlined /> Reset
            </Button>
          </Space>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default Dashboard_s;
